import { ErrorBoundary } from '@components/common';
import { DimensionMain } from './DimensionsMain';
import { ManagementProvider } from './ManagementProvider';
import React from 'react';
import { ManagementProps } from '../utils/atom';

const Management = (props: ManagementProps) => {
  return (
    <ErrorBoundary>
      <ManagementProvider {...props}>
        <DimensionMain {...props} />
      </ManagementProvider>
    </ErrorBoundary>
  );
};

export default React.memo(Management);
